module.exports = __webpack_public_path__ + "assets/chart__book-library.1e27ee75.svg";